var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('span',[_vm._v("COPYRIGHT © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"https://it-tim.si","target":"_blank","rel":"nofollow"}},[_vm._v("I.T.Tim d.o.o.")]),_vm._v(", All rights Reserved")])])
}
var staticRenderFns = []

export { render, staticRenderFns }